import React from 'react';
import styles from './Notification.module.css';
import cn from 'classnames';

const NotificationComponent = ({ show, onClose, text, variant }) => {
  const getBodyClassName = () => {
    switch (variant) {
      case 'info':
        return styles.infoBody;
      case 'warning':
        return styles.warningBody;
      case 'success':
        return styles.successBody;
      case 'error':
        return styles.errorBody;
      default:
        return styles.infoBody;
    }
  };
  return (
    <div show={show} className={cn('position-fixed p-3', styles.notification)}>
      <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
        <div className={cn('toast-header', styles.header)}>
          <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div className={cn('toast-body text-muted', getBodyClassName())}>{text}</div>
      </div>
    </div>
  );
};

export default NotificationComponent;
